import { action, computed } from 'mobx';
import { Entity } from '../../core/entity';
import type { IImageSliceViewModel, JSONConfig } from '../interfaces';
import type { SlicerMode, SliceType } from '../modules/images/interfaces';

export class ImageSliceViewModel extends Entity<JSONConfig.ImageSlice> implements IImageSliceViewModel {
  public get descriptor(): SliceType {
    return this.props.descriptor;
  }

  @computed
  public get label(): string {
    return this.props.label;
  }

  @computed
  public get color(): string {
    return this.props.color;
  }

  @computed
  public get borderColor(): string {
    return this.props.borderColor;
  }

  @computed
  public get isVisible(): boolean {
    return this.props.isVisible;
  }

  @computed
  public get imageSlicerMode(): SlicerMode {
    return this.props.imageSlicerMode;
  }

  @action
  public setVisibility(visibility: boolean): void {
    this.props.isVisible = visibility;
  }

  @action
  public setImageSlicerMode(mode: SlicerMode): void {
    this.props.imageSlicerMode = mode;
  }
}
